/* eslint-disable camelcase */
export enum UpdateSaleTypes {
  GET_UPDATE_SALE_REQUEST = '@update_sale/GET_UPDATE_SALE_REQUEST',
  GET_UPDATE_SALE_SUCCESS = '@update_sale/GET_UPDATE_SALE_SUCCESS',
  GET_UPDATE_SALE_FAILURE = '@update_sale/GET_UPDATE_SALE_FAILURE',
}

export interface ServiceTypes {
  id: number;
  nome: string;
}

export interface SaleTypes {
  venda: {
    cliente_id: number;
    contato_cliente_id: number;
    created_at: string;
    data_cancelamento: null;
    data_vencimento: string;
    formas_pagamento_id: number;
    from_site: number;
    id: number;
    motivo_cancelamento_id: null;
    observacao: string;
    parcelas: number;
    recompra: number;
    renovacao_automatica: number;
    status_carrinho_id: number;
    status_id: number;
    tipo_venda_id: number;
    updated_at: string;
    usuario_criacao_id: number;
    usuario_modificacao_id: number;
    valor_adicional: string;
    valor_base: string;
    valor_desconto_negociacao: string;
    valor_total: string;
    valor_variacao_forma_pagamento: string;
  };
}

export interface SaleDadosTypes {
  sale: SaleTypes;
  vigencia_fim: string | null;
  vigencia_inicio: string | null;
  services_name: Array<ServiceTypes>;
  return_code: number | null;
  is_charged: boolean;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface UpdateSaleState {
  update_sale: SaleDadosTypes;
  readonly request: RequestState;
}
